"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.parse-int.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputRadio = props => {
  var _props$error, _props$helpText;
  const {
    name,
    value,
    label,
    onChange: _onChange,
    error,
    defaultValue
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom pb-2"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)("col-sm-12 m-0 pt-2 pb-2", {
      "is-invalid": error
    })
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12"
  }, props.options ? props.options.map((option, index) => {
    let defaultChecked = null;
    if (parseInt(value) === parseInt(option.id)) defaultChecked = "checked";else if (value === option.id) defaultChecked = "checked";else if (defaultValue === option.id && value === "") defaultChecked = "checked";
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "form-check form-check-inline"
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "form-check-label",
      htmlFor: name + index
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: (0, _classnames.default)("form-check-input", {
        "is-invalid": error
      }),
      type: "radio",
      defaultChecked: defaultChecked,
      name: name,
      id: name + index,
      value: option.id,
      onChange: e => _onChange(e.target.value)
    }), option.name));
  }) : null), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: (_props$error = props.error) !== null && _props$error !== void 0 ? _props$error : ""
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: (_props$helpText = props.helpText) !== null && _props$helpText !== void 0 ? _props$helpText : ""
  }))));
};
var _default = FormInputRadio;
exports.default = _default;